export default __webpack_public_path__ + "static/media/Tea Ceremony-0532_tn.0100f6bd.jpg";